export default "__VITE_ASSET__CMCaFUkh__"